import homeActive from '~/assets/images/tabbar/icon-tab-bar-home-active.svg'
import home from '~/assets/images/tabbar/icon-tab-bar-home.svg'
import library from '~/assets/images/tabbar/icon-tab-bar-library.svg'
import libraryActive from '~/assets/images/tabbar/icon-tab-bar-library-active.svg'
import me from '~/assets/images/tabbar/icon-tab-bar-me.svg'
import meActive from '~/assets/images/tabbar/icon-tab-bar-me-active.svg'
// tab栏数据
export const TAB_BAR_LIST = [
    {name: 'other.home', path: '/', icon: home, activeIcon: homeActive},
    {name: 'other.library', path: '/library', icon: library, activeIcon: libraryActive},
    {name: 'other.me', path: '/me', icon: me, activeIcon: meActive}
]

export const PAY_ENTRY = {
    '/vip': "membership_page",
    '/reader': "reading_page",
    '/me': "profile_page",
}

// 域名网站名称映射关系
export const DOMAIN_NAME_MAP = {
    "https://www.halonovel.com": "halonovel",
    "http://www.halonovel.com": "halonovel",
    "https://www.noveliax.com": "noveliax",
    "http://www.noveliax.com": "noveliax",
    "https://www.noveloria.com": "novelOria",
    "http://www.noveloria.com": "novelOria",
    "https://www.novelessa.com": "novelEssa",
    "http://www.novelessa.com": "novelEssa",
    "https://www.noveldrift.com": "novelDrift",
    "http://www.noveldrift.com": "novelDrift",
    "https://www.noveluno.com": "novelUno",
    "http://www.noveluno.com": "novelUno",
    "https://www.runenovel.com": "runeNovel",
    "http://www.runenovel.com": "runeNovel",
    "https://www.veranovel.com": "veraNovel",
    "http://www.veranovel.com": "veraNovel",
    "https://www.neonnovel.com": "neonNovel",
    "http://www.neonnovel.com": "neonNovel",
    "https://www.orbnovel.com": "orbNovel",
    "http://www.orbnovel.com": "orbNovel",
    "https://www.draconovel.com": "draconovel",
    "http://www.draconovel.com": "draconovel",
    "https://www.solianovel.com": "solianovel",
    "http://www.solianovel.com": "solianovel",
    "https://www.horizonnovel.com": "horizonnovel",
    "http://www.horizonnovel.com": "horizonnovel",
    'https://www.velunovel.com': 'velunovel',
    'http://www.velunovel.com': 'velunovel',
    'https://www.lumovel.com': 'lumovel',
    'http://www.lumovel.com': 'lumovel',
    'https://www.veloranovel.com': 'veloranovel',
    'http://www.veloranovel.com': 'veloranovel',
    'https://www.zyronovel.com': 'zyronovel',
    'http://www.zyronovel.com': 'zyronovel',
    'https://www.novellurexa.com': 'novellurexa',
    'http://www.novellurexa.com': 'novellurexa',
    'https://www.mystovanovel.com': 'mystovanovel',
    'http://www.mystovanovel.com': 'mystovanovel',
    'https://www.avenovel.com': 'avenovel',
    'http://www.avenovel.com': 'avenovel',
    'https://www.elynovel.com': 'elynovel',
    'http://www.elynovel.com': 'elynovel',
    'https://www.elunovel.com': 'elunovel',
    'http://www.elunovel.com': 'elunovel',
    'https://www.virelnovel.com': 'virelnovel',
    'http://www.virelnovel.com': 'virelnovel',
    'https://www.talevoranovel.com': 'talevoranovel',
    'http://www.talevoranovel.com': 'talevoranovel',
    'https://www.novelvirexa.com': 'novelvirexa',
    'http://www.novelvirexa.com': 'novelvirexa',
    'https://www.dreamvellenovel.com': 'dreamvellenovel',
    'http://www.dreamvellenovel.com': 'dreamvellenovel',
    'https://www.plotaranovel.com': 'plotaranovel',
    'http://www.plotaranovel.com': 'plotaranovel',
    "http://localhost:3000" :"TEST1",
    "https://h5-site1.supergo.io":"TEST1",
    "http://h5-site1.supergo.io":"TEST1",
    "https://h5-site2.supergo.io":"TEST1",
    "http://h5-site2.supergo.io":"TEST1"
}

export const DOMAIN_LANGUAGE_MAP: Record<string, string> = {
    'localhost:3000': 'en',
    'h5-site1.supergo.io': 'en',
    'h5-site2.supergo.io': 'ko',
    'www.orbnovel.com': 'ko',
    'www.neonnovel.com': 'ja',
    'www.veranovel.com': 'de',
    'www.runenovel.com': 'fr',
    'www.noveluno.com': 'th',
    'www.draconovel.com': 'pt',
    'www.solianovel.com': 'it',
    'www.horizonnovel.com': 'es',
    'www.noveldrift.com': 'en',
    'www.halonovel.com': 'en',
    'www.novelessa.com': 'en',
    'www.noveloria.com': 'en',
    'www.noveliax.com': 'en',
    'pre.noveliax.com': 'en',
    'www.velunovel.com': 'en',
    'www.lumovel.com': 'en',
    'www.veloranovel.com': 'en',
    'www.zyronovel.com': 'en',
    'www.novellurexa.com': 'en',
    'www.mystovanovel.com': 'en',
    'www.avenovel.com': 'en',
    'www.elynovel.com': 'en',
    'www.elunovel.com': 'en',
    'www.virelnovel.com': 'en',
    'www.talevoranovel.com': 'en',
    'www.novelvirexa.com': 'en',
    'www.dreamvellenovel.com': 'en',
    'www.plotaranovel.com': 'en',
}

